







 
import { useEffect, useState } from "react";
import { Plus, X, MoreVertical, Pencil, Trash2, FileText } from "lucide-react";
import Cookies from "js-cookie";
import axios from "axios";
import { createPortal } from "react-dom";
import AddInventoryModal from "./InventoryModals/AddInventoryModal";
import UpdateInventoryModal from "./InventoryModals/UpdateInventoryModal";

export default function AddItem() {


  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [responseModal, setResponseModal] = useState({
    show: false,
    success: false,
    message: "",
  });


  const [deletingId, setDeletingId] = useState(null);
 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [inventoryData, setInventoryData] = useState([]);

  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [imageModal, setImageModal] = useState({ isOpen: false, imageUrl: "" });
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
 
  // const IMAGE_BASE = "https://uptask.visiontrek.io";
  const IMAGE_BASE = "https://demouptask.visiontrek.io";
  
 
  const fetchInventory = async () => {
    try {
      const token = Cookies.get("token");
      const res = await axios.get(`${IMAGE_BASE}/api/inventory`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setInventoryData(res.data.data || []);
    } catch (err) {
      console.error("Inventory fetch error", err);
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    fetchInventory();
  }, []);
 
  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };
 
  const handleUpdate = (item) => {
    setSelectedItem(item);
    setIsUpdateModalOpen(true);
    setOpenDropdown(null);
  };
 

  // const handleDelete = async () => {
  //   const token = Cookies.get("token");
  //   setDeleteLoading(true);
  
  //   try {
  //     const res = await axios.delete(
  //       `${IMAGE_BASE}/api/inventory/${deleteItemId}`,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );
  
  //     if (res.data?.success) {
  //       setDeleteModal(false);
  
  //       setResponseModal({
  //         show: true,
  //         success: true,
  //         message: "Item deleted successfully",
  //       });
  
  //       await fetchInventory();
  //     }
  //   } catch (error) {
  //     setResponseModal({
  //       show: true,
  //       success: false,
  //       message: "Delete failed",
  //     });
  //   } finally {
  //     setDeleteLoading(false);
  //     setDeleteItemId(null);
  //   }
  // };
  const handleDelete = async () => {
    const token = Cookies.get("token");
    setDeleteLoading(true);
  
    try {
      const res = await axios.delete(
        `${IMAGE_BASE}/api/inventory/${deleteItemId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      if (res.data?.success) {
        setDeleteModal(false);
  
        setResponseModal({
          show: true,
          success: true,
          message: "Item deleted successfully",
        });
  
        await fetchInventory();
      }
      //  else {
      //   let message = res.data?.message || "Delete failed";
  
      //   if (message.includes("foreign key constraint")) {
      //     message = "This item is assigned. Please unassign it first.";
      //   }
  
      //   setResponseModal({
      //     show: true,
      //     success: false,
      //     message,
      //   });
      // }
  



      else {
        let message = res.data?.message || "Delete failed";
      
        if (message.includes("foreign key constraint")) {
          message = "This item is assigned. Please unassign it first.";
        }
      
        setDeleteModal(false); // ✅ CLOSE DELETE MODAL
      
        setResponseModal({
          show: true,
          success: false,
          message,
        });
      }


    } 
    
    // catch (error) {
    //   console.log("DELETE ERROR:", error);
  
    //   let message = "Delete failed";
  
    //   const backendMessage = error.response?.data?.message || "";
  
    //   if (backendMessage.includes("foreign key constraint")) {
    //     message = "This item is assigned. Please unassign it first.";
    //   }
  
    //   setResponseModal({
    //     show: true,
    //     success: false,
    //     message,
    //   });
    // } 


    catch (error) {
      console.log("DELETE ERROR:", error);
    
      let message = "Delete failed";
      const backendMessage = error.response?.data?.message || "";
    
      if (backendMessage.includes("foreign key constraint")) {
        message = "This item is assigned. Please unassign it first.";
      }
    
      setDeleteModal(false); // ✅ CLOSE DELETE MODAL
    
      setResponseModal({
        show: true,
        success: false,
        message,
      });
    }
    
    finally {
      setDeleteLoading(false);
      setDeleteItemId(null);
    }
  };



  const filteredInventory = inventoryData.filter((item) =>
  item.name?.toLowerCase().includes(search.toLowerCase())
);
 
  return (
    <>
      <div
        className="
        rounded-2xl md:mt-20 p-5
        bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
        text-white border border-white/10 shadow-2xl
      "
      >
        {/* Header */}
      {/* Header */}
<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

{/* LEFT: Title + Search */}
<div className="flex flex-col md:flex-row md:items-center gap-3 w-full">

  <h1 className="text-2xl font-bold whitespace-nowrap">
    Office Inventory
  </h1>

  <div className="relative w-full md:w-[280px]">
    <input
      type="text"
      placeholder="Search by item name..."
      value={search || ""}
      onChange={(e) => setSearch(e.target.value)}
      className="
        w-full pl-4 pr-10 py-2
        rounded-xl
        bg-white/10 border border-white/20
        text-white placeholder:text-white/60
        outline-none
        focus:border-purple-400
        focus:ring-2 focus:ring-purple-500/20
        transition
      "
    />

    {/* Search icon */}
    <span className="absolute right-3 top-2.5 text-white/50 text-sm">
      🔍
    </span>
  </div>
</div>

{/* RIGHT: Button */}
<button
  onClick={() => setIsModalOpen(true)}
  className="
    flex items-center gap-2
    bg-gradient-to-r from-purple-600 to-indigo-600
    hover:from-purple-500 hover:to-indigo-500
    px-5 py-2 rounded-xl text-sm
    shadow-lg shadow-purple-900/30
    transition
    whitespace-nowrap
  "
>
  <Plus size={18} /> Add Inventory
</button>

</div>
 
   
        {/* TABLE (Desktop only) */}
{/* <div className="hidden md:block min-h-[200px] max-h-[450px] overflow-y-auto"> */}

<div className="
  hidden md:block
  min-h-[200px] max-h-[500px]
  overflow-y-auto
  rounded-sm p-4
  border border-white/10
  bg-white/[0.04]
  backdrop-blur-xl
  shadow-inner no-scrollbar
">
  <table className="w-full text-sm">
    <thead className="text-white/70 border-b border-white/10 whitespace-nowrap">
      <tr>
        <th className="py-2 px-2 text-left w-[140px]">Item ID</th>
        <th className="py-2 text-left px-2 ">Name</th>
        <th className="text-left py-2 px-2">Type</th>
        <th className="py-2 px-2 w-[70px]">Units</th>
        <th className="text-left py-2 px-2 w-[90px]">Status</th>
        <th className="text-left py-2 px-2">Vendor</th>
        <th className="text-left py-2 px-2">Mobile</th>
        <th className="py-2 px-2 w-[80px]">Invoice</th>
        <th className="py-2 px-2 w-[80px]">Item Image</th>
        <th className="text-left py-2 px-2 w-[100px]">Purchase Date</th>
        <th className="text-left py-2 px-2 w-[100px]">Warranty Date</th>
        <th className="py-2 px-2 text-left max-w-[220px]">Info</th>
        <th className="py-2 px-2 w-[60px]">Action</th>
      </tr>
    </thead>
 
    <tbody>
      {filteredInventory.map((item) => (
        <tr key={item.id} className="border-b border-white/5 hover:bg-gradient-to-r hover:from-purple-500/10 hover:to-indigo-500/105 whitespace-nowrap">
          <td className="py-2 px-2 font-mono text-xs">{item.item_id}</td>
          <td className="py-2 px-2 font-medium">{item.name}</td>
          <td className="py-2 px-2">{item.item_type}</td>
          <td className="py-2 px-2 text-center">{item.item_units}</td>
          <td className="py-2 px-2">
            <span className={`px-3 py-1 rounded-full text-xs font-medium tracking-wide
              backdrop-blur-md border border-white/10
              ${item.status === "Assignable"
                ? "bg-green-500/20 text-green-300"
                : item.status === "In Use" || item.status === "Assigned"
                ? "bg-yellow-500/20 text-yellow-300"
                : "bg-red-500/20 text-red-300"
              }`}
            >
              {item.status === "In Use" ? "Assigned" : item.status}
            </span>
          </td>
          <td className="py-2 px-2">{item.vendor_name}</td>
          <td className="py-2 px-2">{item.v_mobile_no}</td>
          {/* <td className="py-2 px-2 text-center">
            {item.invoice_image ? (
              <img
                src={`${IMAGE_BASE}/${item.invoice_image}`}
                className="w-8 h-8 rounded object-cover cursor-pointer mx-auto "
                onClick={() =>
                  setImageModal({
                    isOpen: true,
                    imageUrl: `${IMAGE_BASE}/${item.invoice_image}`,
                  })
                }
              />
            ) : (
              <FileText size={16} className="mx-auto text-white/40" />
            )}
          </td> */}

    
<td className="py-2 px-2 text-center">
  {item.invoice_image ? (
    item.invoice_image.endsWith(".pdf") ? (
      // <a
      // href={`${IMAGE_BASE}${item.invoice_image}`}
      
      // target="_blank"
      //   rel="noopener noreferrer"
      //   className="flex justify-center"
      // >
      //   <FileText size={20} className="text-green-400 cursor-pointer" />

        
      // </a>

      <div className="relative group flex justify-center">
  <a
    href={`${IMAGE_BASE}${item.invoice_image}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <FileText size={20} className="text-green-400 cursor-pointer" />
  </a>

  {/* Tooltip */}
  <span className="absolute bottom-full mb-2 hidden group-hover:block text-xs bg-black text-white px-2 py-1 rounded shadow">
    View PDF
  </span>
</div>
    ) : (
      <img
        src={`${IMAGE_BASE}${item.invoice_image}`}
        className="w-8 h-8 rounded object-cover cursor-pointer mx-auto"
        onClick={() =>
          setImageModal({
            isOpen: true,
            imageUrl: `${IMAGE_BASE}${item.invoice_image}`,
          })
        }
      />
    )
  ) : (
    <FileText size={16} className="mx-auto text-white/40" />
  )}
</td>










<td className="py-2 px-2 text-center">
  {item.item_images?.length > 0 ? (
    <img
      src={`${IMAGE_BASE}${item.item_images[0].image}`}
      className="w-8 h-8 rounded object-cover cursor-pointer mx-auto"
      onClick={() =>
        setImageModal({
          isOpen: true,
          imageUrl: `${IMAGE_BASE}${item.item_images[0].image}`,
        })
      }
    />
  ) : (
    <FileText size={16} className="mx-auto text-white/40" />
  )}
</td>


          <td className="py-2 px-2 text-xs opacity-70">
            {item.purchase_date}
          </td>


<td className="py-2 px-2 text-xs opacity-70">
  {item.warranty_date || "—"}
</td>

          <td className="py-2 px-2 truncate max-w-[220px]">
            {item.additional_info || "—"}
          </td>
     

<div className="flex gap-2">
  <button
    // onClick={() => handleEdit(itemData)}
    onClick={() => handleUpdate(item)}
    className="p-2 rounded bg-blue-500 hover:bg-blue-600"
  >
    <Pencil size={16} />
  </button>
{/* 
  <button
    onClick={() => {
      setDeleteItemId(item.item_id);
      setDeleteModal(true);
    }}
    className="p-2 rounded bg-red-500 hover:bg-red-600"
  >
    <Trash2 size={16} />
  </button> */}

<button
  onClick={() => {
    if (item.status === "In Use") {
      setResponseModal({
        show: true,
        success: false,
        message: "This item is assigned. Please unassign it first.",
      });
      return;
    }

    setDeleteItemId(item.item_id);
    setDeleteModal(true);
  }}
  className="p-2 rounded bg-red-500 hover:bg-red-600"
>
  <Trash2 size={16} />
</button>
</div>
 

 
        </tr>
      ))}
    </tbody>
  </table>
</div>
 
{/* MOBILE CARDS */}
<div className="md:hidden space-y-4">
  {inventoryData.map((item) => (
    <div
      key={item.id}
      className="
        rounded-xl p-4
        bg-gradient-to-br from-white/10 to-white/5
        border border-white/10
        shadow-[0_10px_40px_rgba(0,0,0,0.4)]
      "
    >
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-semibold">{item.name}</h3>
        <span className={`text-xs px-2 py-1 rounded-full border border-white/10
          ${item.status === "Assignable"
            ? "bg-green-500/20 text-green-300"
            : item.status === "In Use" || item.status === "Assigned"
            ? "bg-yellow-500/20 text-yellow-300"
            : "bg-red-500/20 text-red-300"}`}>
          {item.status === "In Use" ? "Assigned" : item.status}
        </span>
      </div>
 
      <div className="grid grid-cols-2 gap-2 text-sm opacity-80">
        <p><b>ID:</b> {item.item_id}</p>
        <p><b>Units:</b> {item.item_units}</p>
        <p><b>Type:</b> {item.item_type}</p>
        <p><b>Date:</b> {item.purchase_date}</p>
        <p className="col-span-2"><b>Vendor:</b> {item.vendor_name}</p>
        <p className="col-span-2"><b>Mobile:</b> {item.v_mobile_no}</p>
      </div>
 
      <div className="flex justify-between items-center mt-3">
        {item.invoice_image ? (
          <img
            src={`${IMAGE_BASE}/${item.invoice_image}`}
            className="w-10 h-10 rounded object-cover cursor-pointer"
            onClick={() =>
              setImageModal({
                isOpen: true,
                imageUrl: `${IMAGE_BASE}/${item.invoice_image}`,
              })
            }
          />

          
        ) : (
          <FileText size={18} className="text-white/40" />
        )}
 

 {item.item_images?.length > 0 ? (
  <img
    src={`${IMAGE_BASE}/${item.item_images[0].image}`}
    className="w-10 h-10 rounded object-cover cursor-pointer"
    onClick={() =>
      setImageModal({
        isOpen: true,
        imageUrl: `${IMAGE_BASE}/${item.item_images[0].image}`,
      })
    }
  />
) : (
  <FileText size={18} className="text-white/40" />
)}
        <div className="flex gap-3">
          <button
            onClick={() => handleUpdate(item)}
            className="p-2 bg-blue-500/20 rounded-lg"
          >
            <Pencil size={16} />
          </button>
 
          <button
            onClick={() => handleDelete(item.item_id)}
            className="p-2 bg-red-500/20 rounded-lg text-red-300"
          >
            <Trash2 size={16} />
          </button>
        </div>
      </div>
    </div>
  ))}
</div>
 
      </div>
 
      {/* Modals */}
      <AddInventoryModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          fetchInventory();
        }}
      />
 
      <UpdateInventoryModal
        isOpen={isUpdateModalOpen}
        itemData={selectedItem}
        // onClose={() => {
        //   setIsUpdateModalOpen(false);
        //   fetchInventory();
        // }}
 
 
        onClose={(updated) => {
          setIsUpdateModalOpen(false);
          if (updated) fetchInventory(); // ✅ ONLY WHEN UPDATED
        }}
 
      />
 
      {/* Image Preview */}
      {imageModal.isOpen && createPortal(
        <div
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
          onClick={() =>
            setImageModal({ isOpen: false, imageUrl: "" })
          }
        >
          <div className="bg-[#24155a] border border-white/20 p-4 rounded-xl">
            <img
              src={imageModal.imageUrl}
              className="max-h-[80vh] rounded"
            />
          </div>
        </div>,
          document.body
      )}




{deleteModal &&
  createPortal(
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
      <div className="bg-white rounded-xl p-6 w-[320px] text-center">
        <h2 className="text-lg font-bold mb-3 text-red-600">
          Delete Item?
        </h2>

        <p className="text-gray-600 mb-4">
          Are you sure you want to delete this item?
        </p>

        <div className="flex gap-3">
          <button
            onClick={() => setDeleteModal(false)}
            className="flex-1 bg-gray-300 py-2 rounded"
          >
            Cancel
          </button>

          <button
            onClick={handleDelete}
            disabled={deleteLoading}
            className="flex-1 bg-red-600 text-white py-2 rounded"
          >
            {deleteLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )}





{responseModal.show &&
  createPortal(
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
      <div className="bg-white p-6 rounded-xl w-[300px] text-center">
        <h2 className={`text-lg font-bold mb-3 ${
          responseModal.success ? "text-green-600" : "text-red-600"
        }`}>
          {responseModal.success ? "Success" : "Error"}
        </h2>

        <p className="text-gray-600 mb-4">{responseModal.message}</p>

        <button
          onClick={() => setResponseModal({ ...responseModal, show: false })}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          OK
        </button>
      </div>
    </div>,
    document.body
  )}
    </>
  );
}
 





 
// import { useEffect, useState } from "react";
// import { Plus, X, MoreVertical, Pencil, Trash2, FileText } from "lucide-react";
// import Cookies from "js-cookie";
// import axios from "axios";
// import { createPortal } from "react-dom";
// import AddInventoryModal from "./InventoryModals/AddInventoryModal";
// import UpdateInventoryModal from "./InventoryModals/UpdateInventoryModal";

// export default function AddItem() {


//   const [deleteItemId, setDeleteItemId] = useState(null);
//   const [deleteModal, setDeleteModal] = useState(false);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [responseModal, setResponseModal] = useState({
//     show: false,
//     success: false,
//     message: "",
//   });


//   const [deletingId, setDeletingId] = useState(null);
 
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
//   const [inventoryData, setInventoryData] = useState([]);

//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [imageModal, setImageModal] = useState({ isOpen: false, imageUrl: "" });
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [selectedItem, setSelectedItem] = useState(null);
 
//   // const IMAGE_BASE = "https://uptask.visiontrek.io";
//   const IMAGE_BASE = "https://uptask.visiontrek.io";
  
 
//   const fetchInventory = async () => {
//     try {
//       const token = Cookies.get("token");
//       const res = await axios.get(`${IMAGE_BASE}/api/inventory`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setInventoryData(res.data.data || []);
//     } catch (err) {
//       console.error("Inventory fetch error", err);
//     } finally {
//       setLoading(false);
//     }
//   };
 
//   useEffect(() => {
//     fetchInventory();
//   }, []);
 
//   const toggleDropdown = (id) => {
//     setOpenDropdown(openDropdown === id ? null : id);
//   };
 
//   const handleUpdate = (item) => {
//     setSelectedItem(item);
//     setIsUpdateModalOpen(true);
//     setOpenDropdown(null);
//   };
 

//   const handleDelete = async () => {
//     const token = Cookies.get("token");
//     setDeleteLoading(true);
  
//     try {
//       const res = await axios.delete(
//         `${IMAGE_BASE}/api/inventory/${deleteItemId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
  
//       if (res.data?.success) {
//         setDeleteModal(false);
  
//         setResponseModal({
//           show: true,
//           success: true,
//           message: "Item deleted successfully",
//         });
  
//         await fetchInventory();
//       }
//     } catch (error) {
//       setResponseModal({
//         show: true,
//         success: false,
//         message: "Delete failed",
//       });
//     } finally {
//       setDeleteLoading(false);
//       setDeleteItemId(null);
//     }
//   };




//   const filteredInventory = inventoryData.filter((item) =>
//   item.name?.toLowerCase().includes(search.toLowerCase())
// );
 
//   return (
//     <>
//       <div
//         className="
//         rounded-2xl md:mt-20 p-5
//         bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//         text-white border border-white/10 shadow-2xl
//       "
//       >
//         {/* Header */}
//       {/* Header */}
// <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

// {/* LEFT: Title + Search */}
// <div className="flex flex-col md:flex-row md:items-center gap-3 w-full">

//   <h1 className="text-2xl font-bold whitespace-nowrap">
//     Office Inventory
//   </h1>

//   <div className="relative w-full md:w-[280px]">
//     <input
//       type="text"
//       placeholder="Search by item name..."
//       value={search || ""}
//       onChange={(e) => setSearch(e.target.value)}
//       className="
//         w-full pl-4 pr-10 py-2
//         rounded-xl
//         bg-white/10 border border-white/20
//         text-white placeholder:text-white/60
//         outline-none
//         focus:border-purple-400
//         focus:ring-2 focus:ring-purple-500/20
//         transition
//       "
//     />

//     {/* Search icon */}
//     <span className="absolute right-3 top-2.5 text-white/50 text-sm">
//       🔍
//     </span>
//   </div>
// </div>

// {/* RIGHT: Button */}
// <button
//   onClick={() => setIsModalOpen(true)}
//   className="
//     flex items-center gap-2
//     bg-gradient-to-r from-purple-600 to-indigo-600
//     hover:from-purple-500 hover:to-indigo-500
//     px-5 py-2 rounded-xl text-sm
//     shadow-lg shadow-purple-900/30
//     transition
//     whitespace-nowrap
//   "
// >
//   <Plus size={18} /> Add Inventory
// </button>

// </div>
 
   
//         {/* TABLE (Desktop only) */}
// {/* <div className="hidden md:block min-h-[200px] max-h-[450px] overflow-y-auto"> */}

// <div className="
//   hidden md:block
//   min-h-[200px] max-h-[500px]
//   overflow-y-auto
//   rounded-2xl
//   border border-white/10
//   bg-white/[0.04]
//   backdrop-blur-xl
//   shadow-inner no-scrollbar
// ">
//   <table className="w-full text-sm">
//     <thead className="text-white/70 border-b border-white/10 whitespace-nowrap">
//       <tr>
//         <th className="py-2 px-2 text-left w-[140px]">Item ID</th>
//         <th className="py-2 text-left px-2 ">Name</th>
//         <th className="text-left py-2 px-2">Type</th>
//         <th className="py-2 px-2 w-[70px]">Units</th>
//         <th className="text-left py-2 px-2 w-[90px]">Status</th>
//         <th className="text-left py-2 px-2">Vendor</th>
//         <th className="text-left py-2 px-2">Mobile</th>
//         <th className="py-2 px-2 w-[80px]">Invoice</th>
//         <th className="py-2 px-2 w-[80px]">Item Image</th>
//         <th className="text-left py-2 px-2 w-[100px]">Date</th>
//         <th className="py-2 px-2 text-left max-w-[220px]">Info</th>
//         <th className="py-2 px-2 w-[60px]">Action</th>
//       </tr>
//     </thead>
 
//     <tbody>
//       {filteredInventory.map((item) => (
//         <tr key={item.id} className="border-b border-white/5 hover:bg-gradient-to-r hover:from-purple-500/10 hover:to-indigo-500/105 whitespace-nowrap">
//           <td className="py-2 px-2 font-mono text-xs">{item.item_id}</td>
//           <td className="py-2 px-2 font-medium">{item.name}</td>
//           <td className="py-2 px-2">{item.item_type}</td>
//           <td className="py-2 px-2 text-center">{item.item_units}</td>
//           <td className="py-2 px-2">
//           <span className={`px-3 py-1 rounded-full text-xs font-medium tracking-wide
//   backdrop-blur-md border border-white/10
//               ${item.status === "Assignable"
//                 ? "bg-green-500/20 text-green-300"
//                 : "bg-yellow-500/20 text-yellow-300"}`}>
//               {item.status}
//             </span>
//           </td>
//           <td className="py-2 px-2">{item.vendor_name}</td>
//           <td className="py-2 px-2">{item.v_mobile_no}</td>
//           {/* <td className="py-2 px-2 text-center">
//             {item.invoice_image ? (
//               <img
//                 src={`${IMAGE_BASE}/${item.invoice_image}`}
//                 className="w-8 h-8 rounded object-cover cursor-pointer mx-auto "
//                 onClick={() =>
//                   setImageModal({
//                     isOpen: true,
//                     imageUrl: `${IMAGE_BASE}/${item.invoice_image}`,
//                   })
//                 }
//               />
//             ) : (
//               <FileText size={16} className="mx-auto text-white/40" />
//             )}
//           </td> */}

    
// <td className="py-2 px-2 text-center">
//   {item.invoice_image ? (
//     item.invoice_image.endsWith(".pdf") ? (
//       <a
//       href={`${IMAGE_BASE}${item.invoice_image}`}
      
//       target="_blank"
//         rel="noopener noreferrer"
//         className="flex justify-center"
//       >
//         <FileText size={20} className="text-red-400 cursor-pointer" />
//       </a>
//     ) : (
//       <img
//         src={`${IMAGE_BASE}${item.invoice_image}`}
//         className="w-8 h-8 rounded object-cover cursor-pointer mx-auto"
//         onClick={() =>
//           setImageModal({
//             isOpen: true,
//             imageUrl: `${IMAGE_BASE}${item.invoice_image}`,
//           })
//         }
//       />
//     )
//   ) : (
//     <FileText size={16} className="mx-auto text-white/40" />
//   )}
// </td>


// <td className="py-2 px-2 text-center">
//   {item.item_images?.length > 0 ? (
//     <img
//       src={`${IMAGE_BASE}${item.item_images[0].image}`}
//       className="w-8 h-8 rounded object-cover cursor-pointer mx-auto"
//       onClick={() =>
//         setImageModal({
//           isOpen: true,
//           imageUrl: `${IMAGE_BASE}${item.item_images[0].image}`,
//         })
//       }
//     />
//   ) : (
//     <FileText size={16} className="mx-auto text-white/40" />
//   )}
// </td>


//           <td className="py-2 px-2 text-xs opacity-70">
//             {item.purchase_date}
//           </td>
//           <td className="py-2 px-2 truncate max-w-[220px]">
//             {item.additional_info || "—"}
//           </td>
     

// <div className="flex gap-2">
//   <button
//     // onClick={() => handleEdit(itemData)}
//     onClick={() => handleUpdate(item)}
//     className="p-2 rounded bg-blue-500 hover:bg-blue-600"
//   >
//     <Pencil size={16} />
//   </button>

//   <button
//     // onClick={() => setDeleteModal(true)}
//     onClick={() => {
//       setDeleteItemId(item.item_id);
//       setDeleteModal(true);
//     }}
//     className="p-2 rounded bg-red-500 hover:bg-red-600"
//   >
//     <Trash2 size={16} />
//   </button>
// </div>
 
//  {/* <div className="flex gap-2">
//   <button
//     onClick={() => handleUpdate(item)}
//     className="
//       p-2 rounded-lg
//       bg-blue-500/20 hover:bg-blue-500/30
//       border border-blue-400/20
//       transition
//     "
//   >
//     <Pencil size={16} />
//   </button>

//   <button
//     onClick={() => {
//       setDeleteItemId(item.item_id);
//       setDeleteModal(true);
//     }}
//     className="
//       p-2 rounded-lg
//       bg-red-500/20 hover:bg-red-500/30
//       border border-red-400/20
//       transition
//     "
//   >
//     <Trash2 size={16} />
//   </button>
// </div> */}
 
//         </tr>
//       ))}
//     </tbody>
//   </table>
// </div>
 
// {/* MOBILE CARDS */}
// <div className="md:hidden space-y-4">
//   {inventoryData.map((item) => (
//     <div
//       key={item.id}
//       className="
//         rounded-xl p-4
//         bg-gradient-to-br from-white/10 to-white/5
//         border border-white/10
//         shadow-[0_10px_40px_rgba(0,0,0,0.4)]
//       "
//     >
//       <div className="flex justify-between items-center mb-2">
//         <h3 className="font-semibold">{item.name}</h3>
//         <span className={`text-xs px-2 py-1 rounded-full
//           ${item.status === "Idle"
//             ? "bg-green-500/20 text-green-300"
//             : "bg-yellow-500/20 text-yellow-300"}`}>
//           {item.status}
//         </span>
//       </div>
 
//       <div className="grid grid-cols-2 gap-2 text-sm opacity-80">
//         <p><b>ID:</b> {item.item_id}</p>
//         <p><b>Units:</b> {item.item_units}</p>
//         <p><b>Type:</b> {item.item_type}</p>
//         <p><b>Date:</b> {item.purchase_date}</p>
//         <p className="col-span-2"><b>Vendor:</b> {item.vendor_name}</p>
//         <p className="col-span-2"><b>Mobile:</b> {item.v_mobile_no}</p>
//       </div>
 
//       <div className="flex justify-between items-center mt-3">
//         {item.invoice_image ? (
//           <img
//             src={`${IMAGE_BASE}/${item.invoice_image}`}
//             className="w-10 h-10 rounded object-cover cursor-pointer"
//             onClick={() =>
//               setImageModal({
//                 isOpen: true,
//                 imageUrl: `${IMAGE_BASE}/${item.invoice_image}`,
//               })
//             }
//           />

          
//         ) : (
//           <FileText size={18} className="text-white/40" />
//         )}
 

//  {item.item_images?.length > 0 ? (
//   <img
//     src={`${IMAGE_BASE}/${item.item_images[0].image}`}
//     className="w-10 h-10 rounded object-cover cursor-pointer"
//     onClick={() =>
//       setImageModal({
//         isOpen: true,
//         imageUrl: `${IMAGE_BASE}/${item.item_images[0].image}`,
//       })
//     }
//   />
// ) : (
//   <FileText size={18} className="text-white/40" />
// )}
//         <div className="flex gap-3">
//           <button
//             onClick={() => handleUpdate(item)}
//             className="p-2 bg-blue-500/20 rounded-lg"
//           >
//             <Pencil size={16} />
//           </button>
 
//           <button
//             onClick={() => handleDelete(item.item_id)}
//             className="p-2 bg-red-500/20 rounded-lg text-red-300"
//           >
//             <Trash2 size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   ))}
// </div>
 
//       </div>
 
//       {/* Modals */}
//       <AddInventoryModal
//         isOpen={isModalOpen}
//         onClose={() => {
//           setIsModalOpen(false);
//           fetchInventory();
//         }}
//       />
 
//       <UpdateInventoryModal
//         isOpen={isUpdateModalOpen}
//         itemData={selectedItem}
//         // onClose={() => {
//         //   setIsUpdateModalOpen(false);
//         //   fetchInventory();
//         // }}
 
 
//         onClose={(updated) => {
//           setIsUpdateModalOpen(false);
//           if (updated) fetchInventory(); // ✅ ONLY WHEN UPDATED
//         }}
 
//       />
 
//       {/* Image Preview */}
//       {imageModal.isOpen && createPortal(
//         <div
//           className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
//           onClick={() =>
//             setImageModal({ isOpen: false, imageUrl: "" })
//           }
//         >
//           <div className="bg-[#24155a] border border-white/20 p-4 rounded-xl">
//             <img
//               src={imageModal.imageUrl}
//               className="max-h-[80vh] rounded"
//             />
//           </div>
//         </div>,
//           document.body
//       )}




// {deleteModal &&
//   createPortal(
//     <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
//       <div className="bg-white rounded-xl p-6 w-[320px] text-center">
//         <h2 className="text-lg font-bold mb-3 text-red-600">
//           Delete Item?
//         </h2>

//         <p className="text-gray-600 mb-4">
//           Are you sure you want to delete this item?
//         </p>

//         <div className="flex gap-3">
//           <button
//             onClick={() => setDeleteModal(false)}
//             className="flex-1 bg-gray-300 py-2 rounded"
//           >
//             Cancel
//           </button>

//           <button
//             onClick={handleDelete}
//             disabled={deleteLoading}
//             className="flex-1 bg-red-600 text-white py-2 rounded"
//           >
//             {deleteLoading ? "Deleting..." : "Delete"}
//           </button>
//         </div>
//       </div>
//     </div>,
//     document.body
//   )}





// {responseModal.show &&
//   createPortal(
//     <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
//       <div className="bg-white p-6 rounded-xl w-[300px] text-center">
//         <h2 className={`text-lg font-bold mb-3 ${
//           responseModal.success ? "text-green-600" : "text-red-600"
//         }`}>
//           {responseModal.success ? "Success" : "Error"}
//         </h2>

//         <p className="text-gray-600 mb-4">{responseModal.message}</p>

//         <button
//           onClick={() => setResponseModal({ ...responseModal, show: false })}
//           className="bg-blue-600 text-white px-4 py-2 rounded"
//         >
//           OK
//         </button>
//       </div>
//     </div>,
//     document.body
//   )}
//     </>
//   );
// }
 



 
// import { useEffect, useState } from "react";
// import { Plus, X, MoreVertical, Pencil, Trash2, FileText } from "lucide-react";
// import Cookies from "js-cookie";
// import axios from "axios";
// import { createPortal } from "react-dom";
// import AddInventoryModal from "./InventoryModals/AddInventoryModal";
// import UpdateInventoryModal from "./InventoryModals/UpdateInventoryModal";

// export default function AddItem() {


//   const [deleteItemId, setDeleteItemId] = useState(null);
//   const [deleteModal, setDeleteModal] = useState(false);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [responseModal, setResponseModal] = useState({
//     show: false,
//     success: false,
//     message: "",
//   });


//   const [deletingId, setDeletingId] = useState(null);
 
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
//   const [inventoryData, setInventoryData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [imageModal, setImageModal] = useState({ isOpen: false, imageUrl: "" });
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [selectedItem, setSelectedItem] = useState(null);
 
//   // const IMAGE_BASE = "https://uptask.visiontrek.io";
//   const IMAGE_BASE = "https://uptask.visiontrek.io";
  
 
//   const fetchInventory = async () => {
//     try {
//       const token = Cookies.get("token");
//       const res = await axios.get(`${IMAGE_BASE}/api/inventory`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setInventoryData(res.data.data || []);
//     } catch (err) {
//       console.error("Inventory fetch error", err);
//     } finally {
//       setLoading(false);
//     }
//   };
 
//   useEffect(() => {
//     fetchInventory();
//   }, []);
 
//   const toggleDropdown = (id) => {
//     setOpenDropdown(openDropdown === id ? null : id);
//   };
 
//   const handleUpdate = (item) => {
//     setSelectedItem(item);
//     setIsUpdateModalOpen(true);
//     setOpenDropdown(null);
//   };
 
 
//   // const handleDelete = async (itemId) => {
//   //   // if (!window.confirm("Delete this item?")) return;
 
//   //   const token = Cookies.get("token");
//   //   setDeletingId(itemId); // start loading
 
//   //   try {
//   //     const res = await axios.delete(`${IMAGE_BASE}/api/inventory/${itemId}`, {
//   //       headers: { Authorization: `Bearer ${token}` },
//   //     });
 
//   //     if (res.data?.success) {
//   //       // setInventoryData((prev) => prev.filter((i) => i.id !== id));
//   //       if (res.data?.success) {
//   //         await fetchInventory(); // ✅ THIS IS THE FIX
//   //       }
//   //     }
//   //   } catch {
//   //     alert("Delete failed");
//   //   } finally {
//   //     setDeletingId(null); // stop loading
//   //   }
//   // };
//   const handleDelete = async () => {
//     const token = Cookies.get("token");
//     setDeleteLoading(true);
  
//     try {
//       const res = await axios.delete(
//         `${IMAGE_BASE}/api/inventory/${deleteItemId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
  
//       if (res.data?.success) {
//         setDeleteModal(false);
  
//         setResponseModal({
//           show: true,
//           success: true,
//           message: "Item deleted successfully",
//         });
  
//         await fetchInventory();
//       }
//     } catch (error) {
//       setResponseModal({
//         show: true,
//         success: false,
//         message: "Delete failed",
//       });
//     } finally {
//       setDeleteLoading(false);
//       setDeleteItemId(null);
//     }
//   };
 
//   return (
//     <>
//       <div
//         className="
//         rounded-2xl md:mt-20 p-5
//         bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
//         text-white border border-white/10 shadow-2xl
//       "
//       >
//         {/* Header */}
//         <div className="flex justify-between items-center mb-4">
//           <h1 className="text-2xl font-bold">Office Inventory</h1>
 
//           <button
//             onClick={() => setIsModalOpen(true)}
//             className="
//               flex items-center gap-2
//               bg-purple-600 hover:bg-purple-500
//               px-4 py-2 rounded-lg text-sm whitespace-nowrap mt-4 md:mt-0
//             "
//           >
//             <Plus size={18} /> Add Inventory
//           </button>
//         </div>
 
   
//         {/* TABLE (Desktop only) */}
// <div className="hidden md:block min-h-[200px] max-h-[450px] overflow-y-auto">
//   <table className="w-full text-sm">
//     <thead className="text-white/70 border-b border-white/10 whitespace-nowrap">
//       <tr>
//         <th className="py-2 px-2 text-left w-[140px]">Item ID</th>
//         <th className="py-2 text-left px-2 ">Name</th>
//         <th className="text-left py-2 px-2">Type</th>
//         <th className="py-2 px-2 w-[70px]">Units</th>
//         <th className="text-left py-2 px-2 w-[90px]">Status</th>
//         <th className="text-left py-2 px-2">Vendor</th>
//         <th className="text-left py-2 px-2">Mobile</th>
//         <th className="py-2 px-2 w-[80px]">Invoice</th>
//         <th className="py-2 px-2 w-[80px]">Item Image</th>
//         <th className="text-left py-2 px-2 w-[100px]">Date</th>
//         <th className="py-2 px-2 text-left max-w-[220px]">Info</th>
//         <th className="py-2 px-2 w-[60px]">Action</th>
//       </tr>
//     </thead>
 
//     <tbody>
//       {inventoryData.map((item) => (
//         <tr key={item.id} className="border-b border-white/5 hover:bg-white/5 whitespace-nowrap">
//           <td className="py-2 px-2 font-mono text-xs">{item.item_id}</td>
//           <td className="py-2 px-2 font-medium">{item.name}</td>
//           <td className="py-2 px-2">{item.item_type}</td>
//           <td className="py-2 px-2 text-center">{item.item_units}</td>
//           <td className="py-2 px-2">
//             <span className={`px-3 py-1 rounded-full text-xs
//               ${item.status === "Idle"
//                 ? "bg-green-500/20 text-green-300"
//                 : "bg-yellow-500/20 text-yellow-300"}`}>
//               {item.status}
//             </span>
//           </td>
//           <td className="py-2 px-2">{item.vendor_name}</td>
//           <td className="py-2 px-2">{item.v_mobile_no}</td>
//           <td className="py-2 px-2 text-center">
//             {item.invoice_image ? (
//               <img
//                 src={`${IMAGE_BASE}/${item.invoice_image}`}
//                 className="w-8 h-8 rounded object-cover cursor-pointer mx-auto "
//                 onClick={() =>
//                   setImageModal({
//                     isOpen: true,
//                     imageUrl: `${IMAGE_BASE}/${item.invoice_image}`,
//                   })
//                 }
//               />
//             ) : (
//               <FileText size={16} className="mx-auto text-white/40" />
//             )}
//           </td>

    



// <td className="py-2 px-2 text-center">
//   {item.item_images?.length > 0 ? (
//     <img
//       src={`${IMAGE_BASE}/${item.item_images[0].image}`}
//       className="w-8 h-8 rounded object-cover cursor-pointer mx-auto"
//       onClick={() =>
//         setImageModal({
//           isOpen: true,
//           imageUrl: `${IMAGE_BASE}/${item.item_images[0].image}`,
//         })
//       }
//     />
//   ) : (
//     <FileText size={16} className="mx-auto text-white/40" />
//   )}
// </td>


//           <td className="py-2 px-2 text-xs opacity-70">
//             {item.purchase_date}
//           </td>
//           <td className="py-2 px-2 truncate max-w-[220px]">
//             {item.additional_info || "—"}
//           </td>
     
 
// {/*  
// <td className="px-4 py-3 text-sm relative">
//                             <button
//                               onClick={() => toggleDropdown(item.id)}
//                               className="p-1 hover:bg-gray-200 rounded transition-colors"
//                               disabled={deletingId === item.item_id}
//                             >
//                               {deletingId === item.item_id ? (
//                                 <span className="text-xs text-gray-500">...</span>
//                               ) : (
//                                 <MoreVertical size={18} className="text-gray-600" />
//                               )}
//                             </button>
 
//                             {openDropdown === item.id && (
//                               <div className="absolute right-0 mt-1 w-40 bg-white shadow-lg border border-gray-200 z-10">
//                                 <button
//                                   onClick={() => handleUpdate(item)}
//                                   className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
//                                 >
//                                   <Pencil size={16} />
//                                   Update
//                                 </button>
//                                 <button
//                                   onClick={() => handleDelete(item.item_id)}
//                                   className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
//                                 >
//                                   <Trash2 size={16} />
//                                   Delete
//                                 </button>
//                               </div>
//                             )}
//                           </td> */}


// <div className="flex gap-2">
//   <button
//     // onClick={() => handleEdit(itemData)}
//     onClick={() => handleUpdate(item)}
//     className="p-2 rounded bg-blue-500 hover:bg-blue-600"
//   >
//     <Pencil size={16} />
//   </button>

//   <button
//     // onClick={() => setDeleteModal(true)}
//     onClick={() => {
//       setDeleteItemId(item.item_id);
//       setDeleteModal(true);
//     }}
//     className="p-2 rounded bg-red-500 hover:bg-red-600"
//   >
//     <Trash2 size={16} />
//   </button>
// </div>
 
 
 
//         </tr>
//       ))}
//     </tbody>
//   </table>
// </div>
 
// {/* MOBILE CARDS */}
// <div className="md:hidden space-y-4">
//   {inventoryData.map((item) => (
//     <div
//       key={item.id}
//       className="
//         rounded-xl p-4
//         bg-white/10 border border-white/20
//         backdrop-blur-xl
//         shadow-lg
//       "
//     >
//       <div className="flex justify-between items-center mb-2">
//         <h3 className="font-semibold">{item.name}</h3>
//         <span className={`text-xs px-2 py-1 rounded-full
//           ${item.status === "Idle"
//             ? "bg-green-500/20 text-green-300"
//             : "bg-yellow-500/20 text-yellow-300"}`}>
//           {item.status}
//         </span>
//       </div>
 
//       <div className="grid grid-cols-2 gap-2 text-sm opacity-80">
//         <p><b>ID:</b> {item.item_id}</p>
//         <p><b>Units:</b> {item.item_units}</p>
//         <p><b>Type:</b> {item.item_type}</p>
//         <p><b>Date:</b> {item.purchase_date}</p>
//         <p className="col-span-2"><b>Vendor:</b> {item.vendor_name}</p>
//         <p className="col-span-2"><b>Mobile:</b> {item.v_mobile_no}</p>
//       </div>
 
//       <div className="flex justify-between items-center mt-3">
//         {item.invoice_image ? (
//           <img
//             src={`${IMAGE_BASE}/${item.invoice_image}`}
//             className="w-10 h-10 rounded object-cover cursor-pointer"
//             onClick={() =>
//               setImageModal({
//                 isOpen: true,
//                 imageUrl: `${IMAGE_BASE}/${item.invoice_image}`,
//               })
//             }
//           />

          
//         ) : (
//           <FileText size={18} className="text-white/40" />
//         )}
 

//  {item.item_images?.length > 0 ? (
//   <img
//     src={`${IMAGE_BASE}/${item.item_images[0].image}`}
//     className="w-10 h-10 rounded object-cover cursor-pointer"
//     onClick={() =>
//       setImageModal({
//         isOpen: true,
//         imageUrl: `${IMAGE_BASE}/${item.item_images[0].image}`,
//       })
//     }
//   />
// ) : (
//   <FileText size={18} className="text-white/40" />
// )}
//         <div className="flex gap-3">
//           <button
//             onClick={() => handleUpdate(item)}
//             className="p-2 bg-blue-500/20 rounded-lg"
//           >
//             <Pencil size={16} />
//           </button>
 
//           <button
//             onClick={() => handleDelete(item.item_id)}
//             className="p-2 bg-red-500/20 rounded-lg text-red-300"
//           >
//             <Trash2 size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   ))}
// </div>
 
//       </div>
 
//       {/* Modals */}
//       <AddInventoryModal
//         isOpen={isModalOpen}
//         onClose={() => {
//           setIsModalOpen(false);
//           fetchInventory();
//         }}
//       />
 
//       <UpdateInventoryModal
//         isOpen={isUpdateModalOpen}
//         itemData={selectedItem}
//         // onClose={() => {
//         //   setIsUpdateModalOpen(false);
//         //   fetchInventory();
//         // }}
 
 
//         onClose={(updated) => {
//           setIsUpdateModalOpen(false);
//           if (updated) fetchInventory(); // ✅ ONLY WHEN UPDATED
//         }}
 
//       />
 
//       {/* Image Preview */}
//       {imageModal.isOpen && createPortal(
//         <div
//           className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
//           onClick={() =>
//             setImageModal({ isOpen: false, imageUrl: "" })
//           }
//         >
//           <div className="bg-[#24155a] border border-white/20 p-4 rounded-xl">
//             <img
//               src={imageModal.imageUrl}
//               className="max-h-[80vh] rounded"
//             />
//           </div>
//         </div>,
//           document.body
//       )}




// {deleteModal &&
//   createPortal(
//     <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
//       <div className="bg-white rounded-xl p-6 w-[320px] text-center">
//         <h2 className="text-lg font-bold mb-3 text-red-600">
//           Delete Item?
//         </h2>

//         <p className="text-gray-600 mb-4">
//           Are you sure you want to delete this item?
//         </p>

//         <div className="flex gap-3">
//           <button
//             onClick={() => setDeleteModal(false)}
//             className="flex-1 bg-gray-300 py-2 rounded"
//           >
//             Cancel
//           </button>

//           <button
//             onClick={handleDelete}
//             disabled={deleteLoading}
//             className="flex-1 bg-red-600 text-white py-2 rounded"
//           >
//             {deleteLoading ? "Deleting..." : "Delete"}
//           </button>
//         </div>
//       </div>
//     </div>,
//     document.body
//   )}





// {responseModal.show &&
//   createPortal(
//     <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
//       <div className="bg-white p-6 rounded-xl w-[300px] text-center">
//         <h2 className={`text-lg font-bold mb-3 ${
//           responseModal.success ? "text-green-600" : "text-red-600"
//         }`}>
//           {responseModal.success ? "Success" : "Error"}
//         </h2>

//         <p className="text-gray-600 mb-4">{responseModal.message}</p>

//         <button
//           onClick={() => setResponseModal({ ...responseModal, show: false })}
//           className="bg-blue-600 text-white px-4 py-2 rounded"
//         >
//           OK
//         </button>
//       </div>
//     </div>,
//     document.body
//   )}
//     </>
//   );
// }
 

